<template>
  <div>
    <md-dialog
      :md-active="formShow"
      class="md-scrollbar small-dialog"
    >
      <div class="table-data__tool mb-1">
        <md-dialog-title class="able-data__tool-left">{{ formTitle }}</md-dialog-title>
      </div>

      <md-content class="md-scrollbar" style="overflow: auto;">
        <template v-if="loading">
          <div class="d-flex justify-content-center align-items-center" style="min-height: 150px; ">
            <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
          </div>
        </template>
        <template v-else>
          <fieldset :disabled="formMode === 'view'">
            <form action method="post" enctype="multipart/form-data" class="form-horizontal p-3">
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="name_tc" class="form-control-label" v-required>Name (中文)</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="name_tc"
                    name="name_tc"
                    placeholder
                    class="form-control"
                    v-model="input.name_tc"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="name_en" class="form-control-label">Name (En)</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="name_en"
                    name="name_en"
                    placeholder
                    class="form-control"
                    v-model="input.name_en"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="position" class="form-control-label">Position</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="position"
                    name="position"
                    placeholder
                    class="form-control"
                    v-model="input.position"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="contact_mobile" class="form-control-label">Contact Mobile</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="contact_mobile"
                    name="contact_mobile"
                    placeholder
                    class="form-control"
                    v-model="input.contact_mobile"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="contact_tel" class="form-control-label">Contact Tel</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="contact_tel"
                    name="contact_tel"
                    placeholder
                    class="form-control"
                    v-model="input.contact_tel"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="contact_email" class="form-control-label">Contact Email</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="contact_email"
                    name="contact_email"
                    placeholder
                    class="form-control"
                    v-model="input.contact_email"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="other_contact" class="form-control-label">Other Contact</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="other_contact"
                    name="other_contact"
                    placeholder
                    class="form-control"
                    v-model="input.other_contact"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="remarks" class="form-control-label">Remarks</label>
                </div>
                <div class="col-12 col-md-9">
                  <textarea
                    name="remarks"
                    id="remarks"
                    rows="4"
                    placeholder
                    class="form-control"
                    v-model="input.remarks"
                  ></textarea>
                </div>
              </div>
            </form>
          </fieldset>
          <md-dialog-actions>
            <md-button
              class="md-primary"
              @click="save()"
              v-if="formMode != 'view'"
            >Save</md-button>
            <md-button class="md-primary" @click="$emit('closeVendorContactEdit')">Cancel</md-button>
          </md-dialog-actions>
        </template>
      </md-content>
    </md-dialog>
  </div>
</template>

<script>

import save from 'src/global/save.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

import VendorContactModel from './model/VendorContact'

export default {
  name: 'VendorContactEdit',
  props: {
    formMode: String,
    formShow: Boolean,
    selectedVendor: Object,
    selectedItem: Object,
  },
  data() {
    return {
      input: VendorContactModel(),
      requiredInput: [
        {key: 'name_tc', title: 'Name (中文)'},
      ],
      edit: false,
      datas: null,
      processing: false,
      loading: false,
      modelID: null,
    }
  },
  computed: {
    formTitle: function () {
      if (this.selectedVendor)
        return 'Add new contact in ' + this.selectedVendor.name
      else
        return ''
    }
  },
  watch: {
    formShow: function() {
      this.input = VendorContactModel()
    },
    selectedItem: function (data) {
      if (data) {
        this.modelID = data.id
        this.$http
          .get(this.WebService.vendorContact + '/' + data.id)
          .then((res) => {
            this.input = res.data.data
          })
      } else {
        this.input = VendorContactModel()
      }
    },
  },
  methods: {
    validation,
    save() {

      if( this.processing !== false ) return

      if( typeof this.validation !== 'undefined' && this.validation() ) {

        this.processing = true

        this.input.vendor_id = this.selectedVendor.id

        if (this.input.id) {
          this.$http
            .put(this.WebService.vendorContact + '/' + this.input.id, this.input)
            .then((res) => {
              this.input = res.data
              this.$emit('closeVendorContactEdit')
              this.$emit('reload')
            })
            .catch((err) => {
              this.alertNotice({
                type: 'danger',
                title: 'Failed',
                content: err.data,
              })
            })
            .finally(() => {
              this.processing = false
            })
        } else {
          this.$http
            .post(this.WebService.vendorContact, this.input)
            .then((res) => {
              this.$emit('closeVendorContactEdit')
              this.$emit('reload')
            })
            .catch((err) => {
              this.alertNotice({
                type: 'danger',
                title: 'Failed',
                content: err.data,
              })
            })
            .finally(() => {
              this.processing = false
            })
        }
      }
    },
  }
}
</script>